import { Injectable } from '@angular/core'
import { createStore } from '@ngneat/elf'
import { Doka360ProjectModel } from '../../generated/efp-api'
import { getEntity, upsertEntities, withEntities } from '@ngneat/elf-entities'
import { Doka360ProjectsDao } from '../services/dao/doka360-projects.dao'

export const doka360ProjectStore = createStore(
  { name: 'project' },
  withEntities<Doka360ProjectModel>()
)

@Injectable({
  providedIn: 'root',
})
export class Doka360ProjectsRepository {
  constructor(private readonly doka360ProjectsDao: Doka360ProjectsDao) {}

  public async findOneById(doka360ProjectsUid: string): Promise<Doka360ProjectModel | undefined> {
    let doka360Project = doka360ProjectStore.query(getEntity(doka360ProjectsUid))

    if (!doka360Project) {
      doka360Project = await this.doka360ProjectsDao.findOneById(doka360ProjectsUid)

      if (doka360Project) {
        doka360ProjectStore.update(upsertEntities(doka360Project))
      }
    }

    return doka360Project
  }
}
